import React, { memo, ReactNode } from 'react';
import { textAlignmentMap } from '../../content/configuration';
import { theme } from '@minted/minted-components';
import { css } from '@emotion/react';

const wrapperStyles = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.x4};

  margin-left: ${theme.spacing.x5};
  margin-right: ${theme.spacing.x5};
`;

export type DisplayWrapperProps = {
  children: ReactNode,
  textAlignment: string,
};

const DisplayWrapper = ({
  children,
  textAlignment,
}: DisplayWrapperProps) => (
  <div
    css={
      [
        wrapperStyles,
        textAlignmentMap.get(textAlignment),
      ]
    }
  >
    {children}
  </div>
);

const MemoizedDisplayWrapper = memo(DisplayWrapper);

export { MemoizedDisplayWrapper as DisplayWrapper };
